import React from 'react';
import { onDeleteclient } from "../../store/actions"
import MantineButton from '../../components/mantine/button';
import MantineGroup from '../../components/mantine/group';
import { useDispatch } from 'react-redux';

const DeleteConfirmation = ({ modalclose,clientData, handleDelete, currentPrimaryColor }: any) => {
    
    const dispatch = useDispatch(); 
    const Deleteuser = () => {
        const data = clientData?.id ;
        dispatch(onDeleteclient(data, handleDelete));
    };

    return (

        <div className="text-center">
            <strong style={{ fontSize: '14px' }}>
                Are you sure you want to delete <span style={{ color: '#ff0000' }}>{clientData?.name}</span>?
            </strong>

            <MantineGroup position="right" className="mt-6 justify-end">

                <MantineButton name={'Cancel'} className={"bg-secondary_color hover:bg-hover_secondary_btn mt-[15px] text-sm font-thin !w-[100px] "} onClick={modalclose} >Cancel</MantineButton>
                <MantineButton name={'Delete'} className={"mt-[15px] text-sm font-thin !w-[90px] mr-3"} color={currentPrimaryColor} onClick={Deleteuser}>Delete</MantineButton>

            </MantineGroup>
        </div>

    );
};



export default DeleteConfirmation;

